import { useMutation } from '@apollo/client';
import { SUBMIT_GAME_IQ_ATTEMPT } from '../../apollo/mutations/gameIQ';

const useSubmitGameIQAttempt = () => {
  const [submitAttempt] = useMutation(SUBMIT_GAME_IQ_ATTEMPT);

  const submitQuiz = async ({ sport, level, answers }) => {
    const { data } = await submitAttempt({
      variables: {
        input: { sport, level, answers }
      }
    });
    return data.submitGameIQAttempt;
  };

  return { submitQuiz };
};

export default useSubmitGameIQAttempt;